import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import AdminCircle from './AdminCircle'
import administratorType from '../common/types/administratorType'

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 5px;
  justify-content: space-between;
  list-style: none;
  margin: 0;
  margin-bottom: 40px;
  list-style-type: none;

  &:after {
    content: "";
    flex: auto;
    max-width: 5rem;
  }
`

const AdminList = ({ admins }) => {
  return (
    <List>
      {
        admins.map(admin => {
          return (
            <li key={`admin-${admin.rid}`}>
              <AdminCircle admin={admin} />
            </li>
          )
        })
      }
    </List>
  )
}

AdminList.propTypes = {
  admins: PropTypes.arrayOf(administratorType)
}

export default AdminList
